import { FC, SVGProps } from 'react';

export const ODPLogoSmall: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    viewBox="0 0 28 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.83624e-07 42.4976L20.8828 0.00013248L28 0.000132408L7 42.4976L6.83624e-07 42.4976Z"
      fill="url(#paint0_linear_4254_119671)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4254_119671"
        x1="8.43046"
        y1="0.877298"
        x2="15.3774"
        y2="43.2954"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0078D6" />
        <stop offset="1" stopColor="#16E1CB" />
      </linearGradient>
    </defs>
  </svg>
);
